import { useQuery } from "react-query";
import FullWidthContainer from "../../components/FullWidthContainer";
import VacancyList from "../../components/vacancy/VacancyList";
import { useVacanciesState } from "../../states/vacancy-state/vacancy.state";
import { SetItemsAction } from "../../helpers/state-helpers/crud-actions";
import useAuthData from "../../auth/useAuthData";
import { useGlobalState } from "../../states/global-state/global.state";
import { useEffect, useState } from "react";
import { useVacancyApi } from "../../apis/vacancy-api";

function TeacherAbsencesView() {
  const { dispatch } = useVacanciesState();
  const { currentTeacher, currentSchool } = useAuthData();
  const { setIsLoading } = useGlobalState();
  const [isInitialized, setIsInitialized] = useState(false);
  const { getVacanciesOfSchool } = useVacancyApi();

  useQuery(["vacancies", dispatch, currentTeacher?.id], {
    queryFn: () =>
      getVacanciesOfSchool(currentSchool!.id).then((vs) =>
        vs.filter((v) => v.absentTeacher.id === currentTeacher?.id),
      ),

    onSuccess: (values) => {
      dispatch(new SetItemsAction(values));
    },
    onSettled: () => setIsInitialized(true),
    enabled: !!dispatch && !!currentTeacher && !!currentSchool,
    refetchInterval: 15000,
  });

  useEffect(() => {
    setIsLoading(!isInitialized);
  }, [isInitialized, setIsLoading]);

  return (
    <>
      <FullWidthContainer className="bg-nid_grey">
        <>
          <main>
            <section>
              <VacancyList></VacancyList>
            </section>
          </main>
        </>
      </FullWidthContainer>
    </>
  );
}

export default TeacherAbsencesView;
